import React from 'react';
import logo from './../assets/Logo_EssilorLuxottica_white.png';

const Footer: React.FC = () => {

    return (
        <div className="footer">
            <div>
                &copy; EssilorLuxottica {new Date().getFullYear()}
            </div>
            <div className="footer-logo-container">
                <img className="footer-logo" src={logo} alt="Logo" />
                <h1>Document Editor</h1>
            </div>
        </div>
    );
};

export default Footer;